import IScroll                       from 'iscroll';
import SupportResponseCollectionView from 'scripts/defa/support/view-support-response-collection-view';
import SupportSearchForm             from 'scripts/defa/support/view-support-search-form';
import Container                     from 'scripts/poppet/container';
import template                      from 'templates/supportContainer.jst.html'

/**
 * defa.views.SupportContainer
 * The left side support panel.
 * @version 1.2.0
 */

const selectors = {
	// application selectors
	buttonClose   : '[data-click=support-close]',
	regionSearch  : '[data-region=support-search]',
	regionResponse: '[data-region=support-response]',
	buttonHeader  : '[data-click=show-support]',
	
	scrollWrap: '.response-wrap',
};

const channel = Bb.Radio.channel( 'objects' );

const SupportContainer = Container.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template     : template,
	className    : 'support-panel',
	closeBehavior: 'nothing',
	
	ui: {
		close: selectors.buttonClose,
	},
	
	events: {
		'click @ui.close': 'onClickClose',
	},
	
	regions: {
		search  : selectors.regionSearch,
		response: selectors.regionResponse,
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// lifecycle event handlers
	
	/**
	 * Triggers just as the view is added to the DOM.
	 * @void
	 */
	onAttach: function () {
		
		let i        = 0,
			self     = this,
			iAnimate = setInterval( function () {
			
				// increment
				i++;
			
				// animate into position
				if ( 2 === i ) {
					if ( $( window ).outerWidth() >= 1200 ) {
						self.$el.addClass( 'in-pos' );
						$( '.app-wrap' ).addClass( 'has-support' );
					}
				}
			
				// attach the search field
				if ( 3 === i ) {
					self.attachSearch();
				}
			
			}, 300 );
		
		// add a listener to the support button in the header:
		$( selectors.buttonHeader ).on( 'click', function () {
			self.showSupportFrame();
		} );
		
		// set IScroll
		self.setIScroll();
		
		$( window ).on( 'resize', function () {
			self.setIScroll();
		} );
		
	},
	
	// @ui event handleres
	
	/**
	 * Triggers when you click the close button.
	 * @void
	 */
	onClickClose: function () {
		this.hideSupportFrame();
	},
	
	// childView event handlers
	
	/**
	 * Triggers when a child view triggers a search event.
	 * @param {string} query  The search query.
	 * @void
	 */
	onChildviewSearch: function ( query ) {
		this.trigger( 'search', query );
	},
	
	/**
	 * Triggers when the response view requests to open a response.
	 * @param {view}   childView  The view where the event originated from.
	 * @param {int}    id         The id of the view's model.
	 * @param {string} type       The class of the model.
	 * @void
	 */
	onChildviewOpen: function ( childView ) {
		
		let id   = childView.model.get( 'bid' ),
			type = childView.model.get( 'class' ).toLowerCase();
		
		if ( 'installer' === type ) {
			type = 'customer';
		}
		
		this.trigger( 'open', id, type );
	},
	
	/**
	 * Triggers when the response view requests to start the migrate process.
	 * @param {view}   childView  The view where the event originated from.
	 * @param {int}    id         The id of the view's model.
	 * @void
	 */
	onChildviewMigrate: function ( childView ) {
		
		let id = childView.model.get( 'bid' );
		
		this.trigger( 'migrate', id );
	},
	
	/**
	 * Triggers when the response view requests to start the installed process.
	 * @param {view}   childView  The view where the event originated from.
	 * @param {int}    id         The id of the view's model.
	 * @void
	 */
	onChildviewInstalled: function ( childView ) {
		let id = childView.model.get( 'bid' );
		
		this.trigger( 'installed', childView.model.get( 'bid' ) );
	},
	
	/**
	 * Triggers when the response view requests to view a log.
	 * @param {view}   childView  The view where the event originated from.
	 * @param {int}    id         The id of the view's model.
	 * @param {string} type       The class of the model.
	 * @void
	 */
	/* onChildviewLog: function( childView ) {
	 
	 var id = childView.model.get( 'bid' );
	 
	 var type;
	 switch( childView.model.get( 'class' ) ) {
	 
	 case 'CUSTOMER'  :
	 case 'INSTALLER' :
	 type = 'billing'
	 break;
	 
	 case 'USER' :
	 type = 'user';
	 break;
	 
	 case 'UNIT' :
	 default     :
	 type = 'device';
	 break;
	 }
	 
	 //this.trigger( 'log', id, type )
	 channelNav.trigger( 'log', [ type, id, 1, ] );
	 }, */
	
	/**
	 * Triggers when the response view resizes.
	 * @void
	 */
	onChildviewResize: function () {
		this.setIScroll();
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Attaches the search field to the Support Panel.
	 * @void
	 */
	attachSearch: function () {
		let supportSearchForm = new SupportSearchForm();
		this.showChildView( 'search', supportSearchForm );
	},
	
	/**
	 * Creates a new response view and attaches it to the Support Panel.
	 * @void
	 */
	attachResponse: function () {
		
		let supportResponseCollectionView = new SupportResponseCollectionView( {
			collection: channel.request( 'ser' ),
		} );
		this.showChildView( 'response', supportResponseCollectionView );
	},
	
	/**
	 * Hides the frame out to the left.
	 * @void
	 */
	hideSupportFrame: function () {
		this.$el.removeClass( 'in-pos' );
		$( '.app-wrap' ).removeClass( 'has-support' );
		
		// remove touch controller
		$( window ).off( 'touchend.outsideSupportFrame' );
	},
	
	/**
	 * Shows the frame in from the left.
	 * @void
	 */
	showSupportFrame: function () {
		
		let self = this;
		
		self.$el.addClass( 'in-pos' );
		$( '.app-wrap' ).addClass( 'has-support' );
		
		// add touch controller to close the support frame as soon as the animation is done.
		_.delay( function () {
			$( window ).on( 'touchend.outsideSupportFrame', function ( event ) {
				// only trigger on touch outside the support frame
				if ( !self.$el.is( event.target ) && 0 === self.$el.has( event.target ).length ) {
					self.hideSupportFrame();
				}
			} );
		}, 300 );
		
	},
	
	/**
	 * Set IScroll on the response view.
	 * @void
	 */
	setIScroll: function () {
		
		if ( !this.scrollable ) {
			this.scrollable = new IScroll( selectors.scrollWrap, {
				mouseWheel: true,
				bounce    : false,
				click     : true,
				
				scrollbars           : 'custom',
				shrinkScrollbars     : 'clip',
				interactiveScrollbars: true,
			} );
			
		} else {
			this.scrollable.refresh();
		}
	},
	
	
} );

export default SupportContainer;